import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styles from "./oc-row.module.scss";
import { getOptionChainTrendName, getValueOrZero, } from "../../../../utils/methods";
const TrendColumn = ({ ltp, prevClose, oi, prevOI }) => {
    const [trend, setTrendName] = useState("");
    const [trendClassName, setTrendClassName] = useState("");
    const getBackgroundColor = (trend) => {
        let value = "";
        if (trend === "LB") {
            value = `${styles.backgroundLB}`;
        }
        else if (trend === "SC") {
            value = `${styles.backgroundSC}`;
        }
        else if (trend === "SB") {
            value = `${styles.backgroundSB}`;
        }
        else if (trend === "LU") {
            value = `${styles.backgroundLU}`;
        }
        else if (trend === "-") {
            value = `${styles.backgroundWhite}`;
        }
        return value;
    };
    const getOCTrend = (ltp, prevClose, oi, prevOI) => {
        const tempLTP = Number(ltp - prevClose);
        const tempOl = Number(oi - prevOI);
        const oiChange = getValueOrZero(oi) - getValueOrZero(prevOI);
        const trend = oiChange == 0
            ? getOptionChainTrendName(prevClose, ltp, true)
            : getOptionChainTrendName(tempLTP, tempOl);
        const trendClassName = getBackgroundColor(trend);
        // console.log(trendClassName, "trendClassName", "m", trend);
        return { trend: trend, trendClassName: trendClassName };
    };
    useEffect(() => {
        const trendInfo = getOCTrend(ltp, prevClose, oi, prevOI);
        setTrendName(trendInfo.trend);
        setTrendClassName(trendInfo.trendClassName);
    }, [ltp, prevClose, oi, prevOI]);
    return (_jsx("div", Object.assign({ className: `${styles.trendWrapper} ${trendClassName}` }, { children: _jsx("div", Object.assign({ className: `${styles.trendBox}  ` }, { children: trend })) })));
};
export default TrendColumn;
